<div id="edit-user-dialog-container" class="modal-dialog" cdkTrapFocus>
  <div class="modal-content" goDialogContent [goDialogContentAriaLabelledBy]="dialogTitleId">
    <div class="goreact-modal-header">
      <h4 class="modal-title" translate="drop-user-dialog_title" [id]="dialogTitleId"></h4>
      <button type="button" class="close-btn" (click)="cancel()" aria-label="Cancel">
        <i class="ficon-app-x"></i>
      </button>
    </div>
    <div class="goreact-modal-body">
      <p translate="drop-user-dialog_message"></p>
    </div>
    <div class="goreact-modal-footer">
      <button class="secondary-btn goreact-btn cancel-btn" (click)="cancel()" translate="common_cancel"></button>
      <button id="drop-user-dialog-close" class="primary-btn goreact-btn" (click)="close()">
        @if (dropping$ | async; as isDropping) {
          <span class="ficon-spinner ficon-spin"></span>
        } @else {
          <span translate="drop-user-dialog_drop"></span>
        }
      </button>
    </div>
  </div>
</div>
